export default {
  name: "LoadingSkeleton"
};